import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dashboardService from './dashboardService'

// Get dashboard data
export const getDashboard = createAsyncThunk(
    'dashboard/getData',
    async (workspace, thunkAPI) => {
    try {
        const state = thunkAPI.getState()
        const token = state.auth.user.token
        const ws = workspace || state.org?.activeWorkspace || 'personal'
        return await dashboardService.getDashboard(token, ws)
    } catch (error) {
        const message = (error.response && 
            error.response.data &&
            error.response.data.message) || 
            error.message || 
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

const initialState = {
    data: null,
    isError: false,
    isSuccess: false, 
    isLoading: false,
    message: ''
}

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false
            state.isSuccess = false
            state.isError = false
            state.message = ''
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(getDashboard.pending, (state) => {
            state.isLoading = true
        })
        .addCase(getDashboard.fulfilled, (state, action) => {
            state.isLoading = false
            state.isSuccess = true
            state.data = action.payload
        })
        .addCase(getDashboard.rejected, (state, action) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload
        })
    }
})

export const { reset } = dashboardSlice.actions
export default dashboardSlice.reducer